import dynamic from 'next/dynamic';
import type { FC } from 'react';
import type { IPage, IProps } from '@/Module/Core/Model/DataModel';
import { LayoutType } from '@/Module/Core/Model/Enum';
const DefaultLayout = dynamic(() => import('@/Module/DefaultLayout/Component/DefaultLayout/DefaultLayout'));
const NoneMobileLayout = dynamic(() => import('@/Module/DefaultLayout/Component/NoneMobileLayout/NoneMobileLayout'));
const ErrorLayout = dynamic(() => import('@/Module/DefaultLayout/Component/ErrorLayout/ErrorLayout'));
const SidebarLayout = dynamic(() => import('@/Module/DefaultLayout/Component/SidebarLayout/SidebarLayout'));
interface IApplicationLayoutProps extends IProps, Pick<IPage, 'layout'> {}
const ApplicationLayout: FC<IApplicationLayoutProps> = ({
  layout,
  children
}) => {
  switch (layout) {
    case LayoutType.NONE:
      return children;
    case LayoutType.ERROR:
      return <ErrorLayout>{children}</ErrorLayout>;
    case LayoutType.NONE_MOBILE:
      return <NoneMobileLayout>{children}</NoneMobileLayout>;
    case LayoutType.SIDEBAR:
      return <SidebarLayout>{children}</SidebarLayout>;
    case LayoutType.DEFAULT:
    default:
      return <DefaultLayout>{children}</DefaultLayout>;
  }
};
export default ApplicationLayout;